import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { RoomImagesResponse, UpdateRoomImagesPayload, updateRoomImages } from '~/services/AccommodationService';

import { roomImagesQueryKeys } from './useGetRoomImages';

export function useUpdateRoomImages() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ roomId, images }: { roomId: string } & UpdateRoomImagesPayload) => {
      const response = await updateRoomImages({ roomId, images });
      return response.result;
    },
    onSuccess: (result, variables) => {
      queryClient.setQueryData<RoomImagesResponse>(roomImagesQueryKeys.detail(variables.roomId), result);
      enqueueSnackbar('Room images updated', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to update room images: ${error.message}`, { variant: 'error' });
    },
  });
}
